export function getSchoolYearFromExitYear(year: number) {
  const currentYear = new Date().getFullYear();
  const newSchoolYear = 12 - (year - currentYear);
  return newSchoolYear > 12 ? 12 : newSchoolYear;
}
